document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('[data-lb-menu-toggle]');
  if (toggle) {
    toggle.addEventListener('click', function () {
      document.body.classList.toggle('lb-menu-open');
    });
  }

  document.querySelectorAll('[data-lb-faq-question]').forEach(function (button) {
    button.addEventListener('click', function () {
      var item = button.closest('.lb-faq-item');
      if (item) item.classList.toggle('is-open');
    });
  });
});
